import { render, staticRenderFns } from "./scoreQuery.vue?vue&type=template&id=cd97e778"
import script from "./scoreQuery.vue?vue&type=script&lang=js"
export * from "./scoreQuery.vue?vue&type=script&lang=js"
import style0 from "./scoreQuery.vue?vue&type=style&index=0&id=cd97e778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports